import processEnvPublic from 'unlikely-env/public'
import mapSliceToComponent from '~/imports/category_page'

import { AlgoliaSearchProvider } from '@unlikelystudio/react-ecommerce-hooks'

import SliceManager from '~/components/Abstracts/SliceManager'
import Tracking from '~/components/Abstracts/Tracking'
import ResultsGrid from '~/components/UI/ResultsGrid'

import LayoutSwitcherProvider from '~/providers/LayoutSwitcherProvider'

import getCategoryPageStaticPropsFunction, {
  getCategoryPageStaticPathsFunction,
} from '~/data/categories-page-data'
import { CategoryPageData } from '~/data/categories-page-data/serializer'

function Category({ slices, resultsGrid, algoliaProps }: CategoryPageData) {
  return (
    <div>
      <AlgoliaSearchProvider
        appId={processEnvPublic('NEXT_PUBLIC_ALGOLIA_APP_ID')}
        apiKey={processEnvPublic('NEXT_PUBLIC_ALGOLIA_API_KEY')}
        initialSearchProps={algoliaProps?.params}
        defaultQueryOptions={{
          refetchOnMount: false,
          initialData: {
            ...algoliaProps?.initialData,
            pageParams: [],
          },
        }}>
        <LayoutSwitcherProvider>
          <ResultsGrid
            initialFacetFilters={algoliaProps?.params?.facetFilters}
            {...resultsGrid}
          />
        </LayoutSwitcherProvider>
      </AlgoliaSearchProvider>
      <SliceManager
        mapSliceTypeToComponent={mapSliceToComponent}
        slicesData={slices}
        withContextPosition={false}
      />
      <Tracking template="collection" />
    </div>
  )
}

export default Category

export const getStaticProps = getCategoryPageStaticPropsFunction()

export const getStaticPaths = getCategoryPageStaticPathsFunction({
  withPage: false,
})
